import { defineStore } from 'pinia';
import { softswiss } from '../transport/softswiss';
import { useStoreSsPlayer } from './player';
import type { IRequestOptions } from '~/types/transport/requestOptions';

export const useStoreSsGamesFavourite = defineStore('ssGamesFavourite', {
  state: () => ({
    gameIds: [] as number[],
    requestPromise: null as Promise<any> | null,
  }),
  actions: {
    async load(options?: IRequestOptions): Promise<void> {
      if (!useStoreSsPlayer().isPlayerAuthorised) {
        this.gameIds = [];
        return;
      }

      if (!this.requestPromise) {
        this.requestPromise = softswiss()
          .get({
            path: '/api/player/favorite_games',
            cacheble: false,
            ...options,
          })
          .finally(() => (this.requestPromise = null));
      }

      const favouritesData: number[] = await this.requestPromise;

      if (favouritesData && favouritesData.length) {
        this.gameIds = favouritesData;
      } else {
        this.gameIds = [];
      }
    },

    /**
     * function for add game into favourite list and save it into SS api
     *
     * @param context - context object
     * @param gameId - id of game in selected currency
     **/
    async addToFavorite(gameId: number) {
      await softswiss().put({
        path: `/api/player/favorite_games/${gameId}`,
      });

      this.gameIds = [gameId, ...this.gameIds];
    },

    /**
     * function for add game into favourite list and save it into SS api
     *
     * @param context - context object
     * @param gameId - id of game in selected currency
     **/
    async removeFromFavorite(gameId: number) {
      await softswiss().delete({
        path: `/api/player/favorite_games/${gameId}`,
      });

      this.gameIds = this.gameIds.filter((gid) => gid !== gameId);
    },
  },
});
